const firebase = window.firebase;
var firebaseConfig = {
    "projectId": "trivia-18394",
    "appId": "1:730802379644:web:be3178468ae2f0bab7e2f9",
    "databaseURL": "https://trivia-18394.firebaseio.com",
    "storageBucket": "trivia-18394.appspot.com",
    "locationId": "us-central",
    "apiKey": "AIzaSyCGTvLtvWO01poHu_wlhUMz6c6Y04sUNfM",
    "authDomain": "trivia-18394.firebaseapp.com",
    "messagingSenderId": "730802379644",
    "measurementId": "G-YQ452T9PK6"
};
firebase.initializeApp(firebaseConfig);

const firebaseservice = {
    getCurrentQuizName: () => {
        var parts = document.location.pathname.split('/'),
            quizName = 'test'; // Default quiz
        
        try {
            if(parts[1].toLowerCase() == 'admin') {
                quizName = parts[2];
            } else {
                quizName = parts[1];
            }
        } catch(e) {
            console.log(e);
        }
        return quizName;
    },
    logout: async () => {
        return await window.firebase.auth().signOut();
    },
    updateUser: async (user) => {
        const currentUser = firebase.auth().currentUser;
        if (currentUser == null) {
            return false;
        }
        const db = firebase.firestore();
        return await db.collection('users').doc(currentUser.uid).set(user);
    },
    upsertQuiz: async (quiz, saveAnswers) => {
        quiz = JSON.parse(JSON.stringify(quiz));
        const quizName = quiz.quizName || firebaseservice.getCurrentQuizName();
        const correctAnswers = {
            correctAnswers: [],
        };
        for (var i=0; i<quiz.rounds.length; i++) {
            const round = quiz.rounds[i];
            for (var j=0; j<round.questions.length; j++) {
                const question = round.questions[j];
                if (question.answer) {
                    correctAnswers.correctAnswers.push({
                        questionId: question.questionId,
                        answer: question.answer,
                    });
                    delete(question.answer);
                }
            }
        }
        console.log('upsertQuiz', quizName);
        if (!quiz.owner) {
            quiz.owner = firebase.auth().currentUser.uid;
        }
        const db = firebase.firestore();
        try
        {
            await db.collection('quizzes').doc('' + quizName).set(quiz);
            if (correctAnswers && saveAnswers) {
                await db.collection('quizzes/' + quizName + '/correctAnswers').doc('correctAnswers').set(correctAnswers);
            }
        } catch (e) {
            console.log(e);
            return false;
        }
        return true;
    },
    insertUserAnswers: async(round, userAnswers, userDoubled) => {
        const db = firebase.firestore();
        const currentUser = firebase.auth().currentUser;
        var doc = await db.collection('users').doc(currentUser.uid).get();
        await db.collection('quizzes/' + firebaseservice.getCurrentQuizName() + '/userAnswers').doc(currentUser.uid + '-' + round).set({
            round: round,
            teamName: doc.data().teamName,
            uid: currentUser.uid,
            userAnswers: userAnswers,
            userDoubled: userDoubled,
        });
    },
    watchUser: async (listener) => {
        const db = firebase.firestore();
        firebase.auth().onAuthStateChanged(async function(user) {
            if (user) {
                var doc = await db.collection('users').doc(user.uid).get();
                if (!doc.exists) {
                    await db.collection('users').doc(user.uid).set({
                        name: user.displayName,
                        profile_image: user.photoURL,
                        email: user.email
                    });
                    doc = await db.collection('users').doc(user.uid).get();
                }
                await db.collection('users').doc(user.uid).onSnapshot(function(doc) {
                    var data = doc.data();
                    data.uid = user.uid;
                    listener(data);
                });
            } else {
                listener(null);
            }
        })
    },
    watchLatestQuiz: (listener) => {
        const quizName = firebaseservice.getCurrentQuizName();
        const db = firebase.firestore();
        db.collection('quizzes').doc(quizName)
              .onSnapshot(function(doc) {
                  var quiz = doc.data();
                  quiz.quizName = quizName;
                  listener(doc.data());
              });
    },
    watchQuizAnswers: (quiz, listener) => {
        const db = firebase.firestore();
        db.collection('quizzes/' + (quiz ? quiz.quizName : firebaseservice.getCurrentQuizName()) + '/correctAnswers').doc('correctAnswers')
              .onSnapshot(function(doc) {
                  console.log('watchQuizAnswers', doc, doc.data());
                  listener(doc.data());
              });
    },
    watchUserAnswers: (listener) => {
        const db = firebase.firestore();
        db.collection('quizzes/' + firebaseservice.getCurrentQuizName() + '/userAnswers').onSnapshot(function(querySnapshot) {
            var results = [];
            querySnapshot.forEach(function(doc) {
                var data = doc.data();
                data.id = doc.id;
                results.push(data);
            });
            console.log(results);
            listener(results);
        });
    },
    watchCurrentUserAnswers: (listener) => {
        const db = firebase.firestore();
        const currentUser = firebase.auth().currentUser;
        db.collection('quizzes/' + firebaseservice.getCurrentQuizName() + '/userAnswers').where("uid", "==", currentUser.uid).onSnapshot(function(querySnapshot) {
            var results = [];
            querySnapshot.forEach(function(doc) {
                var data = doc.data();
                data.id = doc.id;
                results.push(data);
            });
            listener(results);
        });
    },
    watchQuizzes: async (listener) => {
        const db = firebase.firestore();
        var collection = db.collection('quizzes/')
        var doc = await db.collection('users').doc(firebase.auth().currentUser.uid).get();
        if (!doc.data().isAdmin) {
            collection = collection.where('owner', '==', firebase.auth().currentUser.uid);
        }
        collection.onSnapshot(function(querySnapshot) {
            var results = [];
            querySnapshot.forEach(function(doc) {
                var data = doc.data();
                data.id = doc.id;
                results.push(data);
            });
            listener(results);
        });
    },
    upsertUserAnswers: async (userAnswers) => {
        const db = firebase.firestore();
        await db.collection('quizzes/' + firebaseservice.getCurrentQuizName() + '/userAnswers').doc(userAnswers.id).set(userAnswers);
        return true;
    },
    uploadFile: async (quiz, file) => {
        console.log('uploadFile', quiz, file);
        console.log(file.name);
        var storageRef = firebase.storage().ref();
        var parts = file.name.split('.');
        var fileRef = storageRef.child(quiz.quizName +'/'+ Date.now() + '.' + parts[parts.length-1]);
        var results = await fileRef.put(file);
        var url = await results.ref.getDownloadURL();
        return url;
    },
    watchTeamNames: (listener) => {
        const db = firebase.firestore();
        db.collection('users')
            .onSnapshot(function(querySnapshot) {
                var teams = [];
                querySnapshot.forEach(function(doc) {
                    teams.push(doc.data().teamName);
                });
                listener(teams);
            });
    },
};
export default firebaseservice;